
$( document ).ready(function(){

    var currentValue = 0;
    function handleClick(myRadio) {
        alert('Old value: ' + currentValue);
        alert('New value: ' + myRadio.value);
        currentValue = myRadio.value;
    }

    $('#registration-check').change(function() {
        // チェックが入っていたら有効化
        if ( $(this).is(':checked') ){ 
            // ボタンを有効化
            $('#registration-btn').removeClass('disabled');
            $('#registration-line-btn').removeClass('disabled');
        } else { 
            // ボタンを無効化
            $('#registration-btn').addClass('disabled'); 
            $('#registration-line-btn').addClass('disabled'); 
        }
    });

    $('.js-copy-button').click(function(event){
        var targetElement = document.getElementById("js-copy-target");
        // 文字をすべて選択
        targetElement.select();
        // コピー
        document.execCommand("copy");
        alert("successfuly copied the text");
    });
    // $(function(){
    //     setTimeout("$('.podsman-flash').fadeOut('slow')", 2000);
    // });
    $('.user-rankings-nav__item').click(function(){
        console.log("click")
        $(this).parents('.user-rankings-wrapper').find(".user-rankings.active").removeClass("active")
        $(this).parents('.user-rankings-wrapper').find(".user-rankings-nav__item.active").removeClass("active")
        var targetId = "#" + $(this).data('nav-target');
        $(targetId).addClass("active")
        $(this).addClass("active")
    });

    // サンプルボイス一覧での再生
    function endAudio(audioBtnElement) {
        audioBtnElement.removeClass('is-playing')
        var $audio = audioBtnElement.find(".js-profile-audio").get(0);
        $audio.pause();
        $audio.currentTime = 0;

        var $audioProgressBkg = audioBtnElement.find(".user-voice__progress-bkg")
        $audioProgressBkg.css("transition-duration", "0s")
        $audioProgressBkg.removeClass("is-playing")
    }

    function playAudio(audioBtnElement) {
        audioBtnElement.addClass("is-playing")
        
        $(".js-audio-play-btn").not(audioBtnElement).each(function (index, audioBtn) {
            endAudio($(audioBtn))
        });

        var $audio = audioBtnElement.find(".js-profile-audio").get(0);
        var $audioProgressBkg = audioBtnElement.find(".user-voice__progress-bkg")
        var audioDuration = Math.round($audio.duration * .92) //実際のオーディより早くプログレスバーが進むように

        $audioProgressBkg.css("transition-duration", String(audioDuration) + "s")
        $audioProgressBkg.addClass("is-playing")

        $audio.play();
        // $audio.addEventListener("timeupdate", function(){
        // }, false);
        $audio.addEventListener("ended", function(){
            endAudio(audioBtnElement)
        }, false);
    }

    $('.js-audio-play-btn').click(function (event) {
        if($(this).hasClass("is-playing")){
            endAudio($(this))
        }else{
            playAudio($(this))
        }
        // $(this).find(".js-profile-audio").play();
        return false;
    });  


    $('.js-coach-profile-detail__self-purchase-btn').click(function (event) {
        alert("自分のチケットは購入できません");
    }); 

    $('span[id=url-copy-btn]').click(function(){
        var copyFrom = document.createElement("textarea");
        copyFrom.textContent =  location.href;
        var bodyElm = document.getElementsByTagName("body")[0];
        bodyElm.appendChild(copyFrom);
        copyFrom.select();
        var retVal = document.execCommand('copy');
        bodyElm.removeChild(copyFrom);
        alert('URLをコピーしました');
        return retVal;
    });

    var topSwiper1 = new Swiper ('#top-swiper-container-1', {
        // オプションパラメータ(一部のみ抜粋)
        slidesPerGroup: 1,
        slidesPerView: 1, // 何枚のスライドを表示するか
        spaceBetween: 0, // スライド間の余白サイズ(ピクセル)
        direction: 'horizontal', // スライド方向。 'horizontal'(水平) か 'vertical'(垂直)。effectオプションが 'slide' 以外は無効。
        effect: 'slide', // "slide", "fade"(フェード), "cube"(キューブ回転), "coverflow"(カバーフロー) または "flip"(平面回転)
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: {
            delay: 3000,
        },
        loop: true,
        // 前後スライドへのナビゲーションを表示する場合
        navigation: {
          nextEl: '#top-swiper-custom-parent-1 .swiper-button-next', // 次のスライドボタンのセレクタ
          prevEl: '#top-swiper-custom-parent-1 .swiper-button-prev', // 前のスライドボタンのセレクタ
        },
      });

        
    if( $('.swiper-slide--profile-thumb').length > 1 ) {
        //サムネイル
        var sliderThumbnail = new Swiper('#profile-swiper-custom-parent .slider-thumbnail', {
        slidesPerView: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        });

        //スライダー
        var slider = new Swiper('.slider', {
        autoplay: {
            delay: 5000,
        },
        loop: true,
        navigation: {
            nextEl: '#profile-swiper-custom-parent .swiper-button-next',
            prevEl: '#profile-swiper-custom-parent .swiper-button-prev',
        },
        thumbs: {
            swiper: sliderThumbnail
        }
        });
    }
});

